<template>
    <div id="app">
        <BaseFadeTransition>
            <div>
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive"/>
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view>
            </div>
        </BaseFadeTransition>
    </div>
</template>

<script>
//
import { getQueryVariable } from '#/utils/url.js'

//
import Shop from './views/Shop.vue'

//
import { checkCoupon } from "#/utils/coupon.js";
import { checkLocalStorage } from "#/utils/common.js";

//
import { mapState, mapGetters } from 'vuex'

//
import {
    setPrivacy,
    getPrivacy,
} from "#/storage/privacy.js"

//
export default {
    name: 'App',

    components: {
        Shop,
    },

    data() {
        return {
            
        }
    },

    computed: {
        ...mapState({
            userInfo: (state) => state.auth.userInfo,
        }),
    },

    created() {        
        //
        checkCoupon();
        
        const ifSetPrivacy = getPrivacy();

        //
        checkLocalStorage();

        if(ifSetPrivacy == 1)
        {
            setPrivacy(1);
        }
        
        //
        this.$store.dispatch('description/fetchDescription')

        //
        this.$store.dispatch('address/fetchAreaList')

        //
        this.$store.dispatch('auth/getUserInfo')

        //
        this.$store.dispatch('distribution/fetchDistribution')
    },

    methods: {
        back: function () {
            this.$router.go(-1)
        },
    },
}
</script>

<style lang="scss">

#app {
    color: $neutralFontMainColor;
}

</style>
